import { Box, Text } from '@wix/design-system';
import type { PropsWithChildren } from 'react';
import React from 'react';

export const Section: React.FC<PropsWithChildren & { title: React.ReactNode }> = ({
  children,
  title,
}) => {
  return (
    <Box direction="vertical">
      <Box marginBottom="SP4">
        <Text size="small" weight="bold">
          {title}
        </Text>
      </Box>
      <Box direction="vertical" gap="SP3">
        {children}
      </Box>
    </Box>
  );
};
